import { Link } from "react-router-dom";  

interface DeleteButtonProps {
  to?: string;
  onClick?: () => void;
  className?: string;
  iconClassName?: string;
  isLoading?: boolean;
  children?: React.ReactNode;
}

export const DeleteButton = ({ 
  to, 
  onClick,
  className = "", 
  iconClassName = "ph-trash",
  isLoading = false,
  children
}: DeleteButtonProps) => {
  const buttonStyle = {
    borderRadius: "6px",
    padding: "6px 10px",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#dc3545",
    borderColor: "#c82333",
    color: "#fff",
    transition: "all 0.2s ease",
    textDecoration: "none",
    width: "32px",
    height: "32px",
    cursor: "pointer",
    border: "1px solid #c82333",
  };

  const handleMouseEnter = (e: React.MouseEvent<HTMLElement>) => {
    e.currentTarget.style.backgroundColor = "#c82333";
    e.currentTarget.style.transform = "translateY(-1px)";
    e.currentTarget.style.boxShadow = "0 2px 4px rgba(220, 53, 69, 0.3)";
  };

  const handleMouseLeave = (e: React.MouseEvent<HTMLElement>) => {
    e.currentTarget.style.backgroundColor = "#dc3545";
    e.currentTarget.style.transform = "translateY(0)";
    e.currentTarget.style.boxShadow = "none";
  };

  if (onClick) {
    return (
      <span
        onClick={onClick}
        className={`btn btn-sm ${className}`}
        style={buttonStyle}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
        {isLoading && children ? children : <i className={iconClassName} style={{ fontSize: "14px" }}></i>}
      </span>
    );
  }

  return (
    <Link
      to={to || "#"}
      className={`btn btn-sm ${className}`}
      style={buttonStyle}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      {isLoading && children ? children : <i className={iconClassName} style={{ fontSize: "14px" }}></i>}
    </Link>
  );
};

